import { useState } from 'react'

interface Props {
  name: string
  photo?: string
  size?: number
}

const RAMP = [
  'var(--color-market-500)',
  'var(--color-market-600)',
  'var(--color-market-700)',
  'var(--color-market-400)',
]

/**
 * Persona avatar: initials over a domain-coloured circle hashed by name.
 * Uses the Market ramp so personas read as "market" entities per the design system.
 */
export function FitThesisPersonaAvatar({ name, photo, size = 36 }: Props) {
  const [failedPhoto, setFailedPhoto] = useState<string | null>(null)
  const initials =
    name.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?'
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h << 5) - h + name.charCodeAt(i)
  const bg = RAMP[Math.abs(h) % RAMP.length]
  return (
    <div
      className="flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold"
      style={{
        width: size,
        height: size,
        background: bg,
        color: 'var(--color-bg-card)',
        fontSize: size <= 28 ? 11 : 13,
      }}
      aria-hidden="true"
    >
      {photo && failedPhoto !== photo ? (
        <img src={photo} alt="" className="h-full w-full object-cover" onError={() => setFailedPhoto(photo)} />
      ) : (
        initials
      )}
    </div>
  )
}
